<template lang="pug">
    div.infoList
        div.infoRow(v-if="isChampion")
            span.infoLabel {{ $t('profile.fields.businessName') }}:&nbsp;
            span.infoValue {{ user.business.name }}

        div.infoRow
            span.infoLabel {{ $t('profile.fields.fullName') }}:&nbsp;
            span.infoValue {{ user.fullName }}

        div.infoRow
            span.infoLabel {{ $t('profile.fields.email') }}:&nbsp;
            span.infoValue {{ user.email }}

        div.infoRow
            span.infoLabel {{ $t('profile.fields.contactPhone') }}:&nbsp;
            span.infoValue {{ user.phone || '—' }}
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters('auth', ['user', 'isChampion'])
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .infoRow
        padding: 8px 0

    .infoLabel
        font-size: 16px
        color: $theme.sidebar

    .infoValue
        font-size: 16px
        color: $theme.white
        word-break: break-word
</style>
